import * as React from 'react'
import {
  ClusterContainer,
  ClusterMarkerImg,
  ClusterCount,
  ClusterLabel,
} from './mapStyles'
import Alert from 'images/map/warning.svg'
import MaintDue from 'images/map/wrench.svg'
import {ascendColors} from 'common/GlobalStyles'

const ClusterMarker = ({
  cluster,
  pointCount,
}: {
  cluster: any
  pointCount: number
}) => {
  return (
    <ClusterContainer data-cy="clustermarker" data-testid="map-cluster-marker">
      <MarkerCluster count={pointCount} />
      <ClusterCount count={pointCount}>
        {Number(pointCount).toLocaleString()}
      </ClusterCount>
      {cluster.properties.alerts || cluster.properties.maint ? (
        <ClusterLabel>
          {cluster.properties.alerts ? <img src={Alert} /> : <></>}
          {cluster.properties.maint ? <img src={MaintDue} /> : <></>}
        </ClusterLabel>
      ) : null}
    </ClusterContainer>
  )
}
export default ClusterMarker

const MarkerCluster = ({count}: {count: number}) => {
  const outerSize = count > 999 ? 66 : count > 99 ? 50 : 42
  const innerCircle = count > 999 ? 33 : count > 99 ? 25 : 21
  const largeCircleRadii = [32, 28.5, 25.5]
  const mediumCircleRadii = [24, 20.5, 18]
  const smallCircleRadii = [20, 16.5, 14]
  const radii =
    count > 999
      ? largeCircleRadii
      : count > 99
      ? mediumCircleRadii
      : smallCircleRadii
  return (
    <ClusterMarkerImg $outerSize={outerSize}>
      <circle
        cx={innerCircle}
        cy={innerCircle}
        r={radii[0]}
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <circle
        cx={innerCircle}
        cy={innerCircle}
        r={radii[1]}
        fill="white"
        stroke={ascendColors.customPrimary}
      />
      <circle
        cx={innerCircle}
        cy={innerCircle}
        r={radii[2]}
        fill="white"
        stroke={ascendColors.customSecondary}
        strokeWidth={count > 999 ? '5' : '4'}
      />
    </ClusterMarkerImg>
  )
}
